"use client"

import { useEffect, useState } from "react"


export function FallingBooksAnimation() {
  const [books, setBooks] = useState([])


  const bookEmojis = ["📚", "📖", "📕", "📗", "📘", "📙", "📔", "📒", "📓"]


  useEffect(() => {
    // Initialize books
    const initialBooks = []
    for (let i = 0; i < 15; i++) {
      initialBooks.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * -50 - 10, // Start above screen (-10 to -60)
        rotation: Math.random() * 360,
        speed: Math.random() * 0.5 + 0.3, // Slower speed (0.3 to 0.8)
        size: Math.random() * 15 + 15, // Smaller size range (15 to 30px)
        emoji: bookEmojis[Math.floor(Math.random() * bookEmojis.length)],
      })
    }
    setBooks(initialBooks)


    const interval = setInterval(() => {
      setBooks((prevBooks) =>
        prevBooks.map((book) => {
          let newY = book.y + book.speed
          const newRotation = book.rotation + 1


          // Reset book when it goes off screen (below 110%)
          if (newY > 110) {
            newY = Math.random() * -30 - 20 // Reset to -20 to -50
            return {
              ...book,
              y: newY,
              x: Math.random() * 100,
              rotation: Math.random() * 360,
              speed: Math.random() * 0.5 + 0.3,
              size: Math.random() * 15 + 15,
              emoji: bookEmojis[Math.floor(Math.random() * bookEmojis.length)],
            }
          }


          return {
            ...book,
            y: newY,
            rotation: newRotation,
          }
        }),
      )
    }, 50) // Update every 50ms for smooth animation


    return () => clearInterval(interval)
  }, [bookEmojis])


  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      {books.map((book) => (
        <div
          key={book.id}
          className="absolute transition-transform duration-75 ease-linear"
          style={{
            left: `${book.x}%`,
            top: `${book.y}%`,
            transform: `rotate(${book.rotation}deg)`,
            fontSize: `${book.size}px`,
            opacity: 0.6, // Better visibility
            color: '#6366f1', // Indigo color that matches the theme
            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))', // Subtle shadow
          }}
        >
          {book.emoji}
        </div>
      ))}
    </div>
  )
}
